module.exports = __webpack_public_path__ + "static/media/help.f6a50953.svg";